<div class="page gray-font-color font-family bodyBackground processing-request">
  <div class="header-navigation-back">
    <!-- <mat-icon (click)="navigateBack()" data-test="back-arrow-icon">arrow_back</mat-icon> -->
    <span class="title">Processing PCC Order</span>
  </div>
  <app-loading-gif></app-loading-gif>
</div>
